import React, { useState } from 'react'
import { useParams } from 'react-router-dom'

import objectUtils from '../../_helpers/objectUtils'
import reactQuery from '../../_helpers/reactQuery'
import { giftService } from '../../_services'
import translate from '../../locales/en'
import Document from '../Abstract/Document'

const Gift = function () {
  const collectionName = 'Gifts'
  const singleCollectionName = 'Gift'
  const queryKey = collectionName.toLowerCase()
  const singleQueryKey = singleCollectionName.toLowerCase()
  const params = useParams()
  const getQuery = reactQuery.getOneQuery(
    singleQueryKey,
    encodeURIComponent(params.id),
    giftService.get
  )
  const updateMutation = reactQuery.updateMutation(
    giftService.update,
    encodeURIComponent(params.id),
    singleCollectionName,
    singleQueryKey,
    queryKey
  )
  const deleteMutation = reactQuery.deleteMutation(
    giftService.remove,
    encodeURIComponent(params.id),
    singleCollectionName,
    singleQueryKey,
    queryKey
  )
  const [body, setBody] = useState({})
  return (
    <Document
      actions={[
        {
          buttonLabel: `${translate.Update} ${translate[singleCollectionName]}`,
          buttonColor: 'primary',
          onSubmit: (args) => {
            const newBody = objectUtils.compare(getQuery.data, args)
            if (Object.keys(newBody).length)
              return updateMutation.mutate(newBody)
          },
          body,
          setBody,
          withClear: true,
          clearFunction: () => setBody({}),
          form: {
            title: `${translate.Update} ${translate[singleCollectionName]}`,
            inputs: [
              {
                name: 'discountPercent',
                label: 'Discount Percent',
                type: 'number',
                value: getQuery.data?.discountPercent,
              },
              {
                name: 'validityDays',
                label: 'Validity Days',
                type: 'number',
                value: getQuery.data?.validityDays,
              },
              {
                name: 'blacklisted',
                label: 'Blacklisted',
                type: 'boolean',
                value: getQuery.data?.blacklisted,
              },
            ],
          },
        },
        {
          buttonLabel: `${translate.Delete} ${translate[singleCollectionName]}`,
          buttonColor: 'secondary',
          onSubmit: () => deleteMutation.mutate(),
          form: {
            title: `${translate.Delete} ${translate[singleCollectionName]}`,
          },
          confirm: true,
          info: `${translate['Are you sure you want to delete this']} ${translate[singleCollectionName]}`,
        },
      ]}
      title={singleCollectionName}
      getQuery={getQuery}
      many={false}
    />
  )
}
export default Gift
